/** Part index for merged downloads: signal_download_YYYYMMDD_YYYYMMDD.csv.gz → 1, …_p2 → 2, etc. */
export function downloadCsvGzPartIndex(keyOrFilename) {
  const base = (keyOrFilename || '').includes('/')
    ? keyOrFilename.slice(keyOrFilename.lastIndexOf('/') + 1)
    : keyOrFilename || '';
  const m = /^(?:[a-z]+_)?download(?:_\d{8}_\d{8})?(?:_p(\d+))?\.csv\.gz$/i.exec(base);
  if (!m) return Number.MAX_SAFE_INTEGER;
  return m[1] == null ? 1 : parseInt(m[1], 10);
}

/** Sort S3 list objects: *_download*.csv.gz first, then *_p2, … (numeric part index). */
export function sortDownloadFileObjects(objects) {
  if (!Array.isArray(objects)) return [];
  return [...objects].sort((a, b) => {
    const ia = downloadCsvGzPartIndex(a.key);
    const ib = downloadCsvGzPartIndex(b.key);
    if (ia !== ib) return ia - ib;
    const ba = (a.key || '').split('/').pop().toLowerCase();
    const bb = (b.key || '').split('/').pop().toLowerCase();
    return ba.localeCompare(bb);
  });
}

/** Bare blue row icon; use on `<a>` for download links (session cookie auth on navigation). */
export const DOWNLOAD_BTN_CLASS =
  'inline-flex shrink-0 items-center justify-center rounded p-1 text-[#0062FB] transition-colors hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring no-underline';

/**
 * Relative URL for GET …/requested_*_download (302 → presigned S3). Browser sends cookies on navigation.
 */
export function buildFileDownloadHref(path, { id, organization, filename }) {
  if (!organization) {
    return '#';
  }
  const params = new URLSearchParams({
    organization,
  });
  if (id) {
    params.set('id', id);
  }
  if (filename) {
    params.set('filename', filename);
  }
  return `${path}?${params.toString()}`;
}
